/*=============================================== ColorsPage ===============================================*/

import { Tabs, Flexbox } from "tsx-library-julseb"
import type { TabsItemProps } from "tsx-library-julseb/types"

import { ComponentsLayout, CardColor } from "components"

import { colorsLight, colorsDark } from "data"

const ColorsPage = () => {
    const tabs: TabsItemProps[] = [
        {
            title: "Light",
            content: (
                <Flexbox flexDirection="column" gap="s">
                    {colorsLight.map(c => (
                        <CardColor color={c} key={c.css} />
                    ))}
                </Flexbox>
            ),
        },
        {
            title: "Dark",
            content: (
                <Flexbox flexDirection="column" gap="s">
                    {colorsDark.map(c => (
                        <CardColor color={c} key={c.css} />
                    ))}
                </Flexbox>
            ),
        },
    ]

    return (
        <ComponentsLayout>
            <Tabs items={tabs} variant="rounded" justify="stretch" />
        </ComponentsLayout>
    )
}

export default ColorsPage
